/*
 * Used for CKEditor embed videos using oembed. We need to convert the oembed into an iframe
 * Reconfigured and based on: https://gist.github.com/johnfmorton/6b7961fb13e09fe3ef8d5d19ed657614
 * Use for YouTube and Vimeo videos only
 *
 * Should other platforms be required - would need to look at using a service like iframely (https://iframely.com) and use of an APIKey instead.
 */

// Function to extract the video ID from various URL formats
import {findMany} from '../helpers.js';

// Find all oembed elements and replace them with iframes
const oembedElements = findMany('oembed[url]');

const extractVideoId = (url, regex) => {
    const matches = url.match(regex);

    return matches ? matches[1] : null;
};

// Function to create the iframe element
const createIframe = (src) => {
    const iframe = document.createElement('iframe');

    // Setting attributes
    Object.assign(iframe, {
        src,
        width: '1280',
        height: '720',
        frameBorder: '0',
        allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
        allowFullscreen: true,
        title: 'Video player',
        loading: 'lazy',
    });

    return iframe;
};

// Define video platforms with their respective regex patterns and embed URLs
const videoPlatforms = [
    {
        name: 'YouTube',
        embedUrl: (id) => `https://www.youtube.com/embed/${id}`,
        regex: /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    },
    {
        name: 'Vimeo',
        embedUrl: (id) => `https://player.vimeo.com/video/${id}`,
        regex: /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:.*#|.*\/videos\/)?([0-9]+)/,
    },
];

oembedElements.forEach((element) => {
    const url = element.getAttribute('url');

    if (!url) {
        return;
    }

    const platform = videoPlatforms.find((p) => p.regex.test(url));

    if (platform) {
        const videoId = extractVideoId(url, platform.regex);

        if (videoId) {
            const iframe = createIframe(platform.embedUrl(videoId));

            element.parentNode.replaceChild(iframe, element);
        }
    }
});
